import { mapState } from 'vuex'
import theme from '@/component/js/theme'

export default {
  mixins: [theme],
  computed: {
    ...mapState(['designPost'])
  },
  components: {
    Logo: () => import('@/component/common/Logo'),
    ComponentView: () => import('@/app/board/ComponentView')
  }
}
